import RLCard from "../../../../../components/card/RLCard";
import TiCardContent from "../../../../search/components/ticard/components/TiCardContent";
import { Link } from "../../../../../components/link";
import { Tooltip } from "../../report_summary/cards/common";
import { RenderWhen } from "../../../../../components";
import { COMPONENT_IDS, SECTIONS } from "../../../consts";
import { DESCRIPTIONS } from "../../layout-editor/consts";
import { pathToSS } from "../../../util";
import styles from "../../../containers/report_summary/report-summary.module.scss";

interface Props {
  threatName?: string;
  hash?: string;
  sourceId?: number;
  showLink?: boolean;
  renderThreatAdditionalInfo?: boolean;
}

const MalwareFamilyCard = ({
  threatName,
  hash,
  sourceId,
  showLink = true,
  renderThreatAdditionalInfo = false
}: Props) => (
  <RLCard
    header={
      <RLCard.LinkHeader
        title={
          <Tooltip
            placement="top"
            message={DESCRIPTIONS[COMPONENT_IDS.ATTRIBUTION_DATA]}
          >
            <span>Malware Family</span>
          </Tooltip>
        }
        LinkComponent={
          <RenderWhen condition={showLink}>
            <Link
              className={styles.link}
              to={pathToSS(
                hash,
                sourceId,
                SECTIONS.FILE_ANALYSIS.ATTRIBUTION_DATA
              )}
              data-testid="malware_family_sample_data_link"
            >
              Open Full Attribution Data Report
            </Link>
          </RenderWhen>
        }
      />
    }
    content={
      <RLCard.Content>
        <TiCardContent
          family={threatName}
          noBorder
          fileTypesPivotsToSearch
          renderThreatAdditionalInfo={renderThreatAdditionalInfo}
        />
      </RLCard.Content>
    }
    data-testid="malware_family_card"
  />
);

export default MalwareFamilyCard;
